import { render, staticRenderFns } from "./signDocument.vue?vue&type=template&id=3352dfb6"
import script from "./signDocument.vue?vue&type=script&lang=js"
export * from "./signDocument.vue?vue&type=script&lang=js"
import style0 from "./signDocument.vue?vue&type=style&index=0&id=3352dfb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports